import { usePlpViewType } from '../../../hooks/usePlpViewType';
import {
  useApplicationSettingsContext,
  useBreadcrumbContext,
  useCompareContext,
  useRouterContext,
} from '../../../context/PlpContext';
import { useExperiencesContext } from '../../experiences/Experiences';
import { useCachedBasketData } from '@JohnLewisPartnership/jl-design-system/utils/basket/cachedBasket';

export const useProductCardContainerData = () => {
  const compare = useCompareContext();
  const breadcrumbContext = useBreadcrumbContext();
  const { basketBFFService } = useApplicationSettingsContext();
  const { asPath: path } = useRouterContext();
  const experiencesContext = useExperiencesContext();
  const { isListView } = usePlpViewType('useProductCardContainerData');
  const basketData = useCachedBasketData();

  return {
    compare,
    breadcrumbContext,
    basketBFFService,
    experiencesContext,
    isListView,
    path,
    basketData,
  };
};
